import React from 'react';
import { connect } from 'react-redux';
import UnitsColumnListItem from './UnitsColumnListItem';
import UnitsColumnHeader from './UnitsColumnHeader';
import sort from '../../utilities/sort';

/**
 * React Functional Component to display a column of units
 * @param {Object} props - The various props being passed down
 * @description - This component uses React Hooks to set local state to hold the id of the unit currently selected in that column. This is used by the unit item component to set the style for the selected unit.
 */
export const UnconnectedUnitsColumn = (props) => {
  const { unitArray, id, index, columnArr, location } = props;
  /**
   * Function to create the list of child units to be displayed in the column
   * @returns {array} - Array of React components of the list items representing the units that are children of the passed parent unit
   * @description - Creating the list of child units by pulling all the units in then filtering by the parent unit id that is passed in through props. The resulting array is then mapped over to create an array of the list item components that are returned
   */
  const childUnits = () => {
    const children = unitArray.filter((unit) => unit.parent_unit === id);
    const sortedChildren = sort(children, 'name', 'az');
    let unitChildren = sortedChildren.map((unit) => {
      return (
        <UnitsColumnListItem
          unitId={unit.id}
          key={unit.id}
          arrIndex={index}
          selectedUnit={columnArr[index + 1]}
          data-test="units-column-list-item"
        />
      );
    });
    return unitChildren;
  };
  // Creating the div that holds the resulting list item array
  return (
    <div
      className="units-column-view__column-container"
      data-test="units-column">
      <UnitsColumnHeader
        unitId={id}
        location={location}
        data-test="units-column-header"
      />
      <div className="units-column-view__column">{childUnits()}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const unitArray = Object.values(state.units.units);
  return {
    unitObj: state.units.units,
    unitArray: unitArray,
  };
};
export default connect(mapStateToProps)(UnconnectedUnitsColumn);
